import { Injectable } from "@angular/core";
import { BasiqJobType } from "@bitwarden/web-vault/app/models/types/basiq.types";
import { SyncStatusEnum } from "@bitwarden/web-vault/app/models/types/general-types";
import { BasiqActions } from "@bitwarden/web-vault/app/services/syncing/basiq/actions/basiq.actions";

@Injectable({
  providedIn: "root",
})
export class BasiqJobAction extends BasiqActions {
  syncStatus: SyncStatusEnum;

  async getBasiqJobs(jobIds: string): Promise<BasiqJobType[]> {
    try {
      const jobIdArr = jobIds.split(",");
      const jobs: BasiqJobType[] = [];
      for (const jobId of jobIdArr) {
        const glossGetBasiqJobResponse = await this.basiqAuthApi.job(jobId);
        if (glossGetBasiqJobResponse?.job) {
          jobs.push(glossGetBasiqJobResponse.job);
        }
      }

      return jobs;
    } catch (error) {
      await this.glossSyncService.logError([], error, "getting basiq jobs", null);
      return null;
    }
  }
}
